<template>
  <div class="dg-detail">
    <div class="dg-detail__header">
      <div class="dg-detail__title">
        <h4 class="p-m-0">
          <i class="pi pi-cog p-mr-2" />Domestic &amp; General
        </h4>
        <small class="p-text-secondary">
          Integração com o webservice Domestic &amp; General — campos
          marcados com <span class="dg-required">*</span> são obrigatórios.
        </small>
      </div>
      <Button
        label="Atualizar do D&amp;G"
        icon="pi pi-refresh"
        class="p-button-sm p-button-outlined"
        :loading="loading"
        @click="refreshFromDg"
      />
    </div>

    <div class="dg-stepper" role="list" aria-label="Fases da claim">
      <div
        v-for="(phase, idx) in phases"
        :key="phase.key"
        class="dg-stepper__item"
        :class="{
          'is-done': phase.done,
          'is-current': phase.current,
          'is-pending': !phase.done && !phase.current,
        }"
        role="listitem"
      >
        <div class="dg-stepper__node">
          <span class="dg-stepper__circle">
            <i v-if="phase.done" class="pi pi-check" />
            <span v-else>{{ idx + 1 }}</span>
          </span>
          <span v-if="idx < phases.length - 1" class="dg-stepper__bar" />
        </div>
        <div class="dg-stepper__label">
          <strong>{{ phase.label }}</strong>
          <small>{{ phase.date || "Sem especificar" }}</small>
        </div>
      </div>
    </div>

    <TabView>

      <TabPanel header="Detalhes">
        <Fieldset legend="Identificação" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="referral">Referência</label>
              <InputText id="referral" type="text" v-model="serviceOrder.referral" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="policy_number">Nº Apólice</label>
              <InputText id="policy_number" type="text" v-model="serviceOrder.policy_number" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="pat_id">PAT</label>
              <InputText id="pat_id" type="text" v-model="serviceOrder.pat_id" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="claim_status_code">Situação Claim</label>
              <InputText id="claim_status_code" type="text" v-model="serviceOrder.claim_status_code" :disabled="true" />
            </div>
            <div class="p-field p-col-12">
              <label for="problem">Problema</label>
              <Textarea id="problem" :autoResize="true" v-model="serviceOrder.problem" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="failure_type_code">Tipo de Avaria</label>
              <InputText id="failure_type_code" type="text" v-model="serviceOrder.failure_type_code" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="brand_code">Marca</label>
              <InputText id="brand_code" type="text" v-model="serviceOrder.product.brand_code" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="model">Modelo</label>
              <InputText id="model" type="text" v-model="serviceOrder.product.model" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="serial_number">Nº Série</label>
              <InputText id="serial_number" type="text" v-model="serviceOrder.product.serial_number" :disabled="true" />
            </div>
          </div>
        </Fieldset>

        <Fieldset legend="Cliente" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="customer_first_name">Nome</label>
              <InputText id="customer_first_name" type="text" v-model="serviceOrder.customer.first_name" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="customer_last_name">Apelido</label>
              <InputText id="customer_last_name" type="text" v-model="serviceOrder.customer.last_name" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="customer_telephone">Telefone</label>
              <InputText id="customer_telephone" type="text" v-model="serviceOrder.customer.telephone" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="customer_mobile_phone">Telemóvel</label>
              <InputText id="customer_mobile_phone" type="text" v-model="serviceOrder.customer.mobile_phone" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="customer_email">Email</label>
              <InputText id="customer_email" type="text" v-model="serviceOrder.customer.email" :disabled="true" />
            </div>
          </div>
        </Fieldset>

        <Fieldset legend="Entrega" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="delivery_address">Morada</label>
              <InputText id="delivery_address" type="text" v-model="serviceOrder.delivery.address" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="delivery_zip_code">Código Postal</label>
              <InputText id="delivery_zip_code" type="text" v-model="serviceOrder.delivery.zip_code" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="delivery_city">Localidade</label>
              <InputText id="delivery_city" type="text" v-model="serviceOrder.delivery.city" :disabled="true" />
            </div>
          </div>
        </Fieldset>

        <Fieldset legend="Datas" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="start_date">Data Início</label>
              <InputText id="start_date" type="text" v-model="serviceOrder.start_date" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="purchase_date">Data da Compra</label>
              <InputText id="purchase_date" type="text" v-model="serviceOrder.product.purchase_date" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="last_modified_date">Última Modificação</label>
              <InputText id="last_modified_date" type="text" v-model="serviceOrder.last_modified_date" :disabled="true" />
            </div>
          </div>
        </Fieldset>
      </TabPanel>

      <TabPanel header="Recolha &amp; Recepção">
        <Fieldset legend="Recolha" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="pickup_carrier_code">Transportadora <span class="dg-required">*</span></label>
              <InputText id="pickup_carrier_code" v-model="forms.pickup.carrier_code" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="pickup_request_date">Data Solicitação <span class="dg-required">*</span></label>
              <Calendar
                id="pickup_request_date"
                v-model="pickupRequestDate"
                dateFormat="yy-mm-dd"
                :showTime="true"
                :showSeconds="true"
                :showIcon="true"
                :manualInput="true"
                hourFormat="24"
                placeholder="YYYY-MM-DD HH:MM:SS"
              />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="pickup_tracking">Tracking</label>
              <InputText id="pickup_tracking" v-model="forms.pickup.tracking" />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Guardar Recolha" icon="pi pi-truck" @click="run('savePickup', forms.pickup)" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Recepção em Oficina" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="reception_date">Data Recepção <span class="dg-required">*</span></label>
              <Calendar
                id="reception_date"
                v-model="receptionDate"
                dateFormat="yy-mm-dd"
                :showTime="true"
                :showSeconds="true"
                :showIcon="true"
                :manualInput="true"
                hourFormat="24"
                placeholder="YYYY-MM-DD HH:MM:SS"
              />
            </div>
            <div class="p-field p-col-12 p-md-8">
              <label for="reception_serial">Nº Série Recepcionado</label>
              <InputText id="reception_serial" v-model="forms.reception.received_serial_number" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="reception_model">Modelo Oficina</label>
              <InputText id="reception_model" v-model="forms.reception.workshop_model" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="reception_color">Cor</label>
              <InputText id="reception_color" v-model="forms.reception.workshop_color" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="reception_capacity">Capacidade</label>
              <InputText id="reception_capacity" v-model="forms.reception.workshop_capacity" />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Guardar Recepção" icon="pi pi-inbox" @click="run('saveReception', forms.reception)" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Devolução ao Segurado" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="return_carrier_code">Transportadora <span class="dg-required">*</span></label>
              <InputText id="return_carrier_code" v-model="forms.returnDelivery.carrier_code" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="return_tracking">Tracking</label>
              <InputText id="return_tracking" v-model="forms.returnDelivery.tracking" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="return_date">Data Devolução <span class="dg-required">*</span></label>
              <Calendar
                id="return_date"
                v-model="returnSendDate"
                dateFormat="yy-mm-dd"
                :showTime="true"
                :showSeconds="true"
                :showIcon="true"
                :manualInput="true"
                hourFormat="24"
                placeholder="YYYY-MM-DD HH:MM:SS"
              />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Actualizar Tracking" icon="pi pi-refresh" class="p-button-secondary p-mr-2"
              @click="run('updateReturnTracking', { tracking: forms.returnDelivery.tracking })" :loading="loading" />
            <Button label="Guardar Devolução" icon="pi pi-send" @click="run('saveReturn', forms.returnDelivery)" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Observações de Transporte" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12">
              <label for="transport_observations">Observações <span class="dg-required">*</span></label>
              <Textarea id="transport_observations" :autoResize="true" rows="3" v-model="forms.transportObs.observations" />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Guardar Observações" icon="pi pi-save" @click="run('saveTransportObservations', forms.transportObs)" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Visita Técnica" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="visit_date">Data Visita <span class="dg-required">*</span></label>
              <Calendar
                id="visit_date"
                v-model="visitScheduledAt"
                dateFormat="yy-mm-dd"
                :showTime="true"
                :showSeconds="true"
                :showIcon="true"
                :manualInput="true"
                hourFormat="24"
                placeholder="YYYY-MM-DD HH:MM:SS"
              />
            </div>
            <div class="p-field p-col-12 p-md-8">
              <label for="visit_observations">Observações</label>
              <InputText id="visit_observations" v-model="forms.visit.observations" />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Guardar Visita" icon="pi pi-calendar" @click="run('saveVisit', forms.visit)" :loading="loading" />
          </div>
        </Fieldset>
      </TabPanel>

      <TabPanel header="Diagnóstico">
        <Fieldset legend="Diagnóstico Técnico" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="diagnostic_kind">Tipo de Diagnóstico <span class="dg-required">*</span></label>
              <Dropdown
                id="diagnostic_kind"
                v-model="forms.diagnostic.kind"
                :options="diagnosticKinds"
                optionLabel="label"
                optionValue="value"
              />
            </div>
            <div class="p-field p-col-12 p-md-8">
              <label for="diagnostic_observations">Observações</label>
              <InputText id="diagnostic_observations" v-model="forms.diagnostic.observations" />
            </div>
          </div>

          <div v-if="forms.diagnostic.kind === 'repair'" class="p-fluid p-formgrid p-grid">
            <div class="p-field-checkbox p-col-12 p-md-12">
              <Checkbox id="under_warranty" v-model="forms.diagnostic.under_warranty" :binary="true" />
              <label for="under_warranty" class="p-ml-2">Em garantia <span class="dg-required">*</span></label>
            </div>
            <div class="p-field p-col-12 p-md-3" v-for="i in 4" :key="`fc-${i}`">
              <label :for="`failure_code_${i}`">
                Código avaria {{ i }}
                <span v-if="i === 1" class="dg-required">*</span>
              </label>
              <Dropdown
                :id="`failure_code_${i}`"
                v-model="forms.diagnostic.failure_codes[i - 1]"
                :options="familyFailures"
                optionLabel="description"
                optionValue="code"
                :filter="true"
                :showClear="true"
                placeholder="Seleccione"
              />
            </div>
          </div>

          <div v-if="['repair', 'refurbish'].includes(forms.diagnostic.kind)"
            class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="budget_labour">
                Mão-de-obra
                <span v-if="forms.diagnostic.kind === 'refurbish'" class="dg-required">*</span>
              </label>
              <InputNumber
                id="budget_labour"
                v-model="forms.diagnostic.budget_labour"
                mode="currency"
                currency="EUR"
                locale="pt-PT"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                placeholder="0,00 €"
              />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="budget_travel">Deslocação</label>
              <InputNumber
                id="budget_travel"
                v-model="forms.diagnostic.budget_travel"
                mode="currency"
                currency="EUR"
                locale="pt-PT"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                placeholder="0,00 €"
              />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="budget_observations">Observações orçamento</label>
              <InputText id="budget_observations" v-model="forms.diagnostic.budget_observations" />
            </div>
          </div>

          <h6 class="dg-subheader">
            <i class="pi pi-cog p-mr-2" />Peças (até 4)
            <small v-if="forms.diagnostic.kind === 'refurbish'" class="p-ml-2">
              — 1ª peça (nome, referência e IMEI) <span class="dg-required">*</span>
            </small>
          </h6>
          <div class="p-fluid p-formgrid p-grid dg-parts-header p-d-none p-d-md-flex">
            <div class="p-col-12 p-md-3"><small>Nome</small></div>
            <div class="p-col-6 p-md-2"><small>Referência</small></div>
            <div class="p-col-6 p-md-1"><small>Qtd</small></div>
            <div class="p-col-6 p-md-2"><small>Preço</small></div>
            <div class="p-col-6 p-md-2"><small>IMEI</small></div>
            <div class="p-col-12 p-md-2"><small>Data</small></div>
          </div>
          <div v-for="(p, idx) in forms.diagnostic.parts" :key="idx"
            class="p-fluid p-formgrid p-grid dg-parts-row">
            <div class="p-field p-col-12 p-md-3"><InputText placeholder="Nome" v-model="p.name" /></div>
            <div class="p-field p-col-6 p-md-2"><InputText placeholder="Referência" v-model="p.reference" /></div>
            <div class="p-field p-col-6 p-md-1">
              <InputNumber
                placeholder="Qtd"
                v-model="p.quantity"
                :min="0"
                showButtons
                buttonLayout="stacked"
              />
            </div>
            <div class="p-field p-col-6 p-md-2">
              <InputNumber
                placeholder="Preço"
                v-model="p.price"
                mode="currency"
                currency="EUR"
                locale="pt-PT"
                :minFractionDigits="2"
                :maxFractionDigits="2"
              />
            </div>
            <div class="p-field p-col-6 p-md-2"><InputText placeholder="IMEI" v-model="p.imei" /></div>
            <div class="p-field p-col-12 p-md-2">
              <Calendar
                v-model="p.date"
                dateFormat="yy-mm-dd"
                :showIcon="true"
                :manualInput="true"
                placeholder="YYYY-MM-DD"
              />
            </div>
          </div>

          <div class="dg-actions">
            <Button label="Apagar Resolução" icon="pi pi-trash" class="p-button-danger p-button-text p-mr-2"
              @click="run('deleteResolution')" :loading="loading" />
            <Button label="Submeter Diagnóstico" icon="pi pi-check"
              @click="submitDiagnostic" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Negação" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="denial_reason">Motivo <span class="dg-required">*</span></label>
              <Dropdown id="denial_reason" v-model="forms.denial.reason_code"
                :options="denialReasons" optionLabel="description" optionValue="code"
                placeholder="Seleccione um motivo" :filter="true" />
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="denial_observations">Observações</label>
              <InputText id="denial_observations" v-model="forms.denial.observations" />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Negar Reparação" icon="pi pi-times" class="p-button-danger"
              @click="run('saveDeniedRepair', forms.denial)" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Irreparável" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="irreparable_reason">Motivo <span class="dg-required">*</span></label>
              <Dropdown id="irreparable_reason" v-model="forms.irreparable.reason_code"
                :options="irreparableReasons" optionLabel="description" optionValue="code"
                placeholder="Seleccione um motivo" :filter="true" />
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="irreparable_observations">Observações</label>
              <InputText id="irreparable_observations" v-model="forms.irreparable.observations" />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Marcar Irreparável" icon="pi pi-ban" class="p-button-warning"
              @click="run('saveIrreparable', forms.irreparable)" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Pendente de Peças" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field-checkbox p-col-12 p-md-4">
              <Checkbox id="pending_client_contacted" v-model="forms.pendingParts.client_contacted" :binary="true" />
              <label for="pending_client_contacted" class="p-ml-2">
                Cliente contactado <span class="dg-required">*</span>
              </label>
            </div>
            <div class="p-field p-col-12 p-md-8">
              <label for="pending_observations">Observações</label>
              <InputText id="pending_observations" v-model="forms.pendingParts.observations" />
            </div>
          </div>
          <small class="p-text-secondary p-d-block p-mb-2">
            <i class="pi pi-info-circle p-mr-1" />
            O webservice exige adicionalmente a data prevista de pelo menos a
            primeira peça (definida na secção <strong>Diagnóstico → Peças</strong>).
          </small>
          <div class="dg-actions">
            <Button label="Marcar Pendente" icon="pi pi-clock" class="p-button-secondary"
              @click="submitPendingParts" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Refurbish IMEI" class="dg-fieldset" :toggleable="true">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="refurbish_imei">IMEI <span class="dg-required">*</span></label>
              <InputText id="refurbish_imei" v-model="forms.refurbishImei.imei" />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Guardar IMEI" icon="pi pi-mobile"
              @click="run('saveRefurbishImei', forms.refurbishImei)" :loading="loading" />
          </div>
        </Fieldset>
      </TabPanel>

      <TabPanel header="Comunicação">
        <Fieldset legend="Enviar Comunicação" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <label for="comm_type">Departamento</label>
              <InputText id="comm_type" v-model="forms.communication.department_code" />
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="comm_date">Data Comunicação <span class="dg-required">*</span></label>
              <Calendar
                id="comm_date"
                v-model="communicationDate"
                dateFormat="yy-mm-dd"
                :showTime="true"
                :showSeconds="true"
                :showIcon="true"
                :manualInput="true"
                hourFormat="24"
                placeholder="YYYY-MM-DD HH:MM:SS"
              />
            </div>
            <div class="p-field p-col-12">
              <label for="comm_message">Mensagem <span class="dg-required">*</span></label>
              <Textarea id="comm_message" :autoResize="true" rows="4" v-model="forms.communication.message" />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Enviar" icon="pi pi-send"
              @click="run('sendCommunication', forms.communication)" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Cartas" class="dg-fieldset" :toggleable="true">
          <div class="dg-actions dg-actions--start">
            <Button label="Carta de Refurbish" icon="pi pi-file" class="p-button-secondary p-mr-2"
              @click="run('generateRefurbishLetter', {})" :loading="loading" />
            <Button label="Carta de Negação" icon="pi pi-file" class="p-button-secondary"
              @click="run('generateDenialLetter', {})" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Histórico de Comunicações" class="dg-fieldset" :toggleable="true">
          <DataTable
            :value="mappedCommunications"
            responsiveLayout="scroll"
            class="p-datatable-sm"
            :autoLayout="true"
          >
            <template #empty> Não existem registos. </template>
            <Column field="codDepartamentoComunicacionOrigen" header="Origem"></Column>
            <Column field="codDepartamentoComunicacionDestino" header="Destino"></Column>
            <Column field="codTipoComunicacion" header="Tipo"></Column>
            <Column field="textoComunicacion" header="Mensagem"></Column>
            <Column field="fechaComunicacion" header="Data">
              <template #body="slotProps">
                {{ formatLongDateTime(slotProps.data.fechaComunicacion) }}
              </template>
            </Column>
            <template #footer>
              <div class="p-d-flex p-ai-center">
                <i class="pi pi-search p-mr-2" style="font-size: 0.9rem;" />
                <span style="font-size: 0.9rem; font-weight: normal; color: var(--text-color-secondary);">
                  {{ mappedCommunications.length }} Registos
                </span>
              </div>
            </template>
          </DataTable>
        </Fieldset>
      </TabPanel>

      <TabPanel header="Situações">
        <DataTable
          :value="mappedSituations"
          responsiveLayout="scroll"
          class="p-datatable-sm"
          :autoLayout="true"
        >
          <template #empty> Não existem registos. </template>
          <Column field="situacao" header="Situação"></Column>
          <Column field="data" header="Data">
            <template #body="slotProps">
              {{ formatLongDateTime(slotProps.data.data) }}
            </template>
          </Column>
          <Column field="texto" header="Mensagem"></Column>
          <Column field="usuario" header="Utilizador"></Column>
          <Column field="codigoF" header="Código Func. Dpt."></Column>
          <template #footer>
            <div class="p-d-flex p-ai-center">
              <i class="pi pi-search p-mr-2" style="font-size: 0.9rem;" />
              <span style="font-size: 0.9rem; font-weight: normal; color: var(--text-color-secondary);">
                {{ mappedSituations.length }} Registos
              </span>
            </div>
          </template>
        </DataTable>
      </TabPanel>

      <TabPanel header="Encerramento">
        <Fieldset legend="Fechar Claim" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="close_status">Status Final <span class="dg-required">*</span></label>
              <AutoComplete
                key="closeStatusKey"
                v-model="closeStatusCodeWrapper"
                @complete="filterSituationCodes"
                :suggestions="filteredSituationCodes"
                field="label"
                placeholder="Pesquise ou insira um código de situação"
                style="width: 100%"
                :dropdown="true"
                appendTo="body"
              >
              </AutoComplete>
              <div v-if="selectedSituation" class="p-mt-2 p-p-2" style="background: var(--surface-100, #f8f9fa); border-left: 4px solid var(--primary-color, #2563eb); border-radius: 4px;">
                <div style="font-weight: 600; font-size: 0.85rem; color: var(--text-color, #495057);">
                  {{ selectedSituation.label }}
                </div>
                <div style="font-size: 0.75rem; color: var(--text-color-secondary, #6c757d); margin-top: 0.25rem;">
                  {{ selectedSituation.description }}
                </div>
              </div>
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Fechar Claim" icon="pi pi-check-circle" class="p-button-danger"
              @click="closeClaim" :loading="loading" />
          </div>
        </Fieldset>

        <Fieldset legend="Facturação" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="invoice_number">Nº Factura <span class="dg-required">*</span></label>
              <InputText id="invoice_number" v-model="forms.invoice.number" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="invoice_total">Total</label>
              <InputNumber
                id="invoice_total"
                v-model="forms.invoice.amount"
                mode="currency"
                currency="EUR"
                locale="pt-PT"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                placeholder="0,00 €"
              />
              <small class="p-text-secondary">Se vazio, o sistema preenche automaticamente</small>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="invoice_date">Data</label>
              <Calendar
                id="invoice_date"
                v-model="invoiceDate"
                dateFormat="yy-mm-dd"
                :showIcon="true"
                :manualInput="true"
                placeholder="YYYY-MM-DD"
              />
            </div>
          </div>
          <div class="dg-actions">
            <Button label="Criar Factura" icon="pi pi-euro"
              @click="run('createInvoice', forms.invoice)" :loading="loading" />
          </div>
        </Fieldset>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Dropdown from "primevue/dropdown";
import DgService from "../../services/dg.service";
import {
    situationCodes,
} from "@/helpers/dgCatalogs";

const pad = (n) => String(n).padStart(2, "0");

const formatDateTime = (date) => {
  if (!(date instanceof Date) || isNaN(date.getTime())) return "";
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  );
};

const formatDate = (date) => {
  if (!(date instanceof Date) || isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

const parseToDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const normalized = String(value).replace(" ", "T");
  const date = new Date(normalized);
  return isNaN(date.getTime()) ? null : date;
};

const nowDateTimeString = () => formatDateTime(new Date());
const nowDateString = () => formatDate(new Date());

const makeDateTimeProxy = (path) => ({
  get() {
    const segments = path.split(".");
    let value = this;
    for (const segment of segments) {
      value = value?.[segment];
    }
    return parseToDate(value);
  },
  set(value) {
    const segments = path.split(".");
    const last = segments.pop();
    let target = this;
    for (const segment of segments) {
      target = target[segment];
    }
    target[last] = value ? formatDateTime(parseToDate(value)) : "";
  },
});

const makeDateProxy = (path) => ({
  get() {
    const segments = path.split(".");
    let value = this;
    for (const segment of segments) {
      value = value?.[segment];
    }
    return parseToDate(value);
  },
  set(value) {
    const segments = path.split(".");
    const last = segments.pop();
    let target = this;
    for (const segment of segments) {
      target = target[segment];
    }
    target[last] = value ? formatDate(parseToDate(value)) : "";
  },
});

const emptyPart = () => ({
  name: "",
  reference: "",
  quantity: null,
  price: null,
  imei: "",
  date: null,
});

const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = typeof value === "number" ? value : parseFloat(String(value).replace(",", "."));
  return Number.isFinite(n) ? n : null;
};

export default {
  name: "PatDgDetail",
  components: { TabView, TabPanel, Dropdown },
  props: {
    serviceOrder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      diagnosticKinds: [
        { value: "repair", label: "Reparação" },
        { value: "directChange", label: "Mudança Directa" },
        { value: "matrix", label: "Matriz" },
        { value: "technicalValuation", label: "Valoração Técnica" },
        { value: "softCall", label: "Soft Call" },
        { value: "refurbish", label: "Refurbish" },
      ],
      denialReasons: [],
      irreparableReasons: [],
      familyFailures: [],
      filteredSituationCodes: [],
      forms: {
        pickup: { carrier_code: "", tracking: "", request_date: "" },
        reception: {
          reception_date: "",
          received_serial_number: "",
          workshop_model: "",
          workshop_color: "",
          workshop_capacity: "",
        },
        returnDelivery: { carrier_code: "", tracking: "", send_date: "" },
        transportObs: { observations: "" },
        visit: { scheduled_at: "", observations: "", received_serial_number: "" },
        diagnostic: {
          kind: "repair",
          observations: "",
          under_warranty: false,
          failure_codes: ["", "", "", ""],
          budget_labour: "",
          budget_travel: "",
          budget_observations: "",
          parts: [emptyPart(), emptyPart(), emptyPart(), emptyPart()],
        },
        denial: { reason_code: "", observations: "" },
        irreparable: { reason_code: "", observations: "" },
        pendingParts: { client_contacted: false, observations: "" },
        refurbishImei: { imei: "" },
        communication: { department_code: "", message: "", date: "" },
        close: { status_code: "91" },
        invoice: { number: "", amount: "", date: "" },
      },
    };
  },
  watch: {
    serviceOrder: {
      immediate: true,
      handler(serviceOrder) {
        if (serviceOrder) {
          this.syncForms(serviceOrder);
        }
      },
    },
  },
  computed: {
    pickupRequestDate: makeDateTimeProxy("forms.pickup.request_date"),
    receptionDate: makeDateTimeProxy("forms.reception.reception_date"),
    returnSendDate: makeDateTimeProxy("forms.returnDelivery.send_date"),
    visitScheduledAt: makeDateTimeProxy("forms.visit.scheduled_at"),
    communicationDate: makeDateTimeProxy("forms.communication.date"),
    invoiceDate: makeDateProxy("forms.invoice.date"),
    phases() {
      const so = this.serviceOrder || {};
      const transport = so.transport || {};
      const diagnostic = so.diagnostic || {};
      const invoice = so.invoice || {};
      const status = parseInt(so.claim_status_code, 10) || 0;

      const fmt = (v) => {
        if (!v) return "";
        const d = parseToDate(v);
        return d ? formatDateTime(d).slice(0, 16) : "";
      };

      const apertura = so.claim_date || so.created_at || so.created || null;
      const recogida = transport.pickup_request_date || null;
      const recepcion = transport.reception_date || null;
      const diag =
        diagnostic.diagnosed_at ||
        diagnostic.updated_at ||
        (diagnostic.observations || diagnostic.kind || diagnostic.budget_labour
          ? so.updated_at
          : null);
      const resolucion =
        diagnostic.resolved_at ||
        (diagnostic.refurbish_imei || status >= 25 ? so.updated_at : null);
      const devolucion = transport.return_send_date || null;
      const cierre = status >= 91 && status <= 97 ? so.closed_at || so.updated_at : null;
      const facturacion = invoice.number ? invoice.date || invoice.created_at : null;

      const raw = [
        { key: "apertura", label: "Abertura", at: apertura },
        { key: "recogida", label: "Recolha", at: recogida },
        { key: "recepcion", label: "Recepção", at: recepcion },
        { key: "diagnostico", label: "Diagnóstico", at: diag },
        { key: "resolucion", label: "Resolução", at: resolucion },
        { key: "devolucion", label: "Devolução", at: devolucion },
        { key: "cierre", label: "Encerramento", at: cierre },
        { key: "facturacion", label: "Facturação", at: facturacion },
      ];

      let currentAssigned = false;
      return raw.map((p) => {
        const done = !!p.at;
        const current = !done && !currentAssigned;
        if (current) currentAssigned = true;
        return { ...p, done, current, date: fmt(p.at) };
      });
    },
    mappedSituations() {
      const situations = this.serviceOrder?.situations || [];
      const communications = this.serviceOrder?.communications || [];
      const cleanDate = (d) => d ? d.substring(0, 19).replace(" ", "T") : "";

      const list = situations.map((sit) => {
        const sitDate = cleanDate(sit.fechaCambioEstado);
        const comm = communications.find((c) => cleanDate(c.fechaComunicacion) === sitDate);

        return {
          situacao: sit.nombreSituacionClaim || "",
          data: sit.fechaCambioEstado || "",
          texto: comm?.textoComunicacion || "",
          usuario: comm?.codUsuario || comm?.usuario || comm?.codUsuarioAlta || comm?.usuarioAlta || sit.codUsuario || sit.usuario || sit.codUsuarioAlta || sit.usuarioAlta || "",
          codigoF: comm?.codDepartamentoComunicacionOrigen || comm?.codDepartamento || comm?.codFuncionario || comm?.codigoFuncionario || sit.codDepartamento || sit.codFuncionario || sit.codigoFuncionario || "",
        };
      });

      return list.sort((a, b) => {
        const da = new Date(cleanDate(a.data));
        const db = new Date(cleanDate(b.data));
        return da.getTime() - db.getTime();
      });
    },
    mappedCommunications() {
      const communications = this.serviceOrder?.communications || [];
      const cleanDate = (d) => d ? d.substring(0, 19).replace(" ", "T") : "";
      return [...communications].sort((a, b) => {
        const da = new Date(cleanDate(a.fechaComunicacion));
        const db = new Date(cleanDate(b.fechaComunicacion));
        return da.getTime() - db.getTime();
      });
    },
    closeStatusCodeWrapper: {
      get() {
        return this.forms.close.status_code;
      },
      set(val) {
        if (val && typeof val === "object") {
          this.forms.close.status_code = val.code;
        } else {
          this.forms.close.status_code = val || "";
        }
      },
    },
    selectedSituation() {
      const code = this.forms.close.status_code;
      if (!code) return null;
      return situationCodes.find((c) => c.code === String(code));
    },
  },
  mounted() {
    this.loadCatalogs();
  },
  methods: {
    filterSituationCodes(event) {
      const query = event.query.toLowerCase();
      this.filteredSituationCodes = situationCodes.filter((c) =>
        c.label.toLowerCase().includes(query) || String(c.code).toLowerCase().includes(query)
      );
    },
    closeClaim() {
      this.run("closeClaim", this.forms.close);
    },
    formatLongDateTime(value) {
      if (!value) return "";
      const normalized = String(value).replace(" ", "T");
      const d = new Date(normalized);
      if (isNaN(d.getTime())) return value;
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    async loadCatalogs() {
      const [denial, irrep, failures] = await Promise.all([
        DgService.getDenialReasons(),
        DgService.getIrreparableReasons(),
        DgService.getApplianceFamilyFailures()
      ]);

      this.denialReasons = denial;
      this.irreparableReasons = irrep;
      this.familyFailures = failures;
    },
    notify(result, successMsg) {
      if (!result) {
        this.$toast.add({ severity: "error", summary: "Erro", detail: "Sem resposta do servidor", life: 4000 });
        return;
      }
      if (result.status === "OK") {
        this.$toast.add({ severity: "success", summary: "Sucesso", detail: successMsg, life: 3000 });
        if (result.serviceOrder) this.$emit("updated", result.serviceOrder);
      } else {
        this.$toast.add({ severity: "error", summary: "Erro D&G", detail: result.error || "Operação falhou", life: 6000 });
      }
    },
    async run(method, payload) {
      const id = this.serviceOrder.id;
      this.loading = true;
      try {
        const result = await DgService[method](id, payload);
        this.notify(result, `${method} concluído`);
      } finally {
        this.loading = false;
      }
    },
    async refreshFromDg() {
      const id = this.serviceOrder.id;
      this.loading = true;
      try {
        const result = await DgService.refresh(id);
        this.notify(result, "Claim actualizada a partir do D&G");
      } finally {
        this.loading = false;
      }
    },
    syncForms(serviceOrder) {
      const transport = serviceOrder.transport || {};
      const visit = serviceOrder.visit || {};
      const diagnostic = serviceOrder.diagnostic || {};
      const invoice = serviceOrder.invoice || {};

      this.forms.pickup = {
        carrier_code: transport.pickup_carrier_code || "",
        tracking: transport.pickup_tracking || "",
        request_date: transport.pickup_request_date || nowDateTimeString(),
      };
      this.forms.reception = {
        reception_date: transport.reception_date || nowDateTimeString(),
        received_serial_number: serviceOrder.workshop?.received_serial_number || "",
        workshop_model: serviceOrder.workshop?.model || "",
        workshop_color: serviceOrder.workshop?.color || "",
        workshop_capacity: serviceOrder.workshop?.capacity || "",
      };
      this.forms.returnDelivery = {
        carrier_code: transport.return_carrier_code || "",
        tracking: transport.return_tracking || "",
        send_date: transport.return_send_date || nowDateTimeString(),
      };
      this.forms.transportObs = {
        observations: transport.observations || "",
      };
      this.forms.visit = {
        scheduled_at: visit.scheduled_at || nowDateTimeString(),
        observations: visit.observations || "",
        received_serial_number: serviceOrder.workshop?.received_serial_number || "",
      };
      this.forms.diagnostic = {
        ...this.forms.diagnostic,
        observations: diagnostic.observations || "",
        under_warranty: Boolean(diagnostic.under_warranty ?? diagnostic.repair_under_warranty),
        failure_codes: [
          diagnostic.failure_code_1 || diagnostic.failure_codes?.[0] || "",
          diagnostic.failure_code_2 || diagnostic.failure_codes?.[1] || "",
          diagnostic.failure_code_3 || diagnostic.failure_codes?.[2] || "",
          diagnostic.failure_code_4 || diagnostic.failure_codes?.[3] || "",
        ],
        budget_labour: toNumberOrNull(diagnostic.budget_labour),
        budget_travel: toNumberOrNull(diagnostic.budget_travel),
        budget_observations: diagnostic.budget_observations || "",
        parts: this.buildParts(diagnostic.parts),
      };
      this.forms.denial = {
        reason_code: diagnostic.denial_reason_code || "",
        observations: diagnostic.observations || "",
      };
      this.forms.irreparable = {
        reason_code: diagnostic.irreparable_reason_code || "",
        observations: diagnostic.observations || "",
      };
      this.forms.pendingParts = {
        client_contacted: Boolean(diagnostic.client_contacted),
        observations: diagnostic.budget_observations || "",
      };
      this.forms.refurbishImei = {
        imei: diagnostic.refurbish_imei || "",
      };
      this.forms.communication = {
        department_code: serviceOrder.requested_communication_department_code || "",
        message: "",
        date: serviceOrder.last_communication_date || nowDateTimeString(),
      };
      this.forms.close = {
        status_code: serviceOrder.claim_status_code && String(serviceOrder.claim_status_code).startsWith("9")
          ? String(serviceOrder.claim_status_code)
          : "91",
      };
      this.forms.invoice = {
        number: invoice.number || "",
        amount: toNumberOrNull(invoice.amount),
        date: invoice.date || nowDateString(),
      };
    },
    buildParts(parts) {
      const filledParts = Array.isArray(parts) ? parts.slice(0, 4) : [];
      while (filledParts.length < 4) {
        filledParts.push(emptyPart());
      }

      return filledParts.map((part) => {
        const merged = { ...emptyPart(), ...part };
        merged.date = parseToDate(merged.date) || null;
        merged.quantity = toNumberOrNull(merged.quantity);
        merged.price = toNumberOrNull(merged.price);
        return merged;
      });
    },
    submitDiagnostic() {
      const kind = this.forms.diagnostic.kind;
      const map = {
        repair: "saveRepairDiagnostic",
        directChange: "saveDirectChangeDiagnostic",
        matrix: "saveMatrixDiagnostic",
        technicalValuation: "saveTechnicalValuationDiagnostic",
        softCall: "saveSoftCallDiagnostic",
        refurbish: "saveRefurbishDiagnostic",
      };
      const method = map[kind];
      if (!method) return;
      const parts = this.forms.diagnostic.parts
        .filter((p) => p.name || p.reference)
        .map((p) => ({ ...p, date: formatDate(parseToDate(p.date)) }));
      const payload = {
        observations: this.forms.diagnostic.observations,
        budget_labour: this.forms.diagnostic.budget_labour || null,
        budget_travel: this.forms.diagnostic.budget_travel || null,
        budget_observations: this.forms.diagnostic.budget_observations || null,
        parts,
      };
      if (kind === "repair") {
        payload.under_warranty = !!this.forms.diagnostic.under_warranty;
        payload.failure_codes = this.forms.diagnostic.failure_codes.map((c) => c || null);
      }
      this.run(method, payload);
    },
    submitPendingParts() {
      const parts = this.forms.diagnostic.parts.map((p) => ({
        date: formatDate(parseToDate(p.date)),
      }));
      this.run("savePendingParts", {
        client_contacted: !!this.forms.pendingParts.client_contacted,
        observations: this.forms.pendingParts.observations,
        parts,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dg-detail {
  &__header {
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid var(--surface-border, #dee2e6);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;

    h3 {
      display: flex;
      align-items: center;
      font-weight: 600;
    }

    small {
      display: block;
      margin-top: 0.25rem;
    }
  }

  &__title {
    flex: 1 1 auto;
    min-width: 0;
  }
}

.dg-stepper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0;
  margin: 0 0 1.5rem;
  padding: 1rem 0.5rem 0.25rem;
  overflow-x: auto;

  &__item {
    flex: 1 1 0;
    min-width: 90px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    position: relative;
  }

  &__node {
    display: flex;
    align-items: center;
    width: 100%;
    height: 28px;
    position: relative;
  }

  &__circle {
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--surface-200, #e9ecef);
    color: var(--text-color-secondary, #6c757d);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: 600;
    margin: 0 auto;
    border: 2px solid var(--surface-300, #dee2e6);
    z-index: 1;
    transition: background 0.2s, color 0.2s, border-color 0.2s;
  }

  &__bar {
    position: absolute;
    top: 50%;
    left: calc(50% + 14px);
    right: calc(-50% + 14px);
    height: 2px;
    background: var(--surface-300, #dee2e6);
    transform: translateY(-50%);
    z-index: 0;
  }

  &__label {
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    line-height: 1.2;

    strong {
      font-size: 0.8rem;
      color: var(--text-color, #495057);
    }

    small {
      font-size: 0.7rem;
      color: var(--text-color-secondary, #6c757d);
      margin-top: 0.15rem;
    }
  }

  .is-done {
    .dg-stepper__circle {
      background: #22c55e;
      border-color: #22c55e;
      color: #fff;
    }
    .dg-stepper__bar {
      background: #22c55e;
    }
  }

  .is-current {
    .dg-stepper__circle {
      background: #fff;
      border-color: #2563eb;
      color: #2563eb;
      box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.15);
    }
    .dg-stepper__label strong {
      color: #2563eb;
    }
  }
}

.dg-fieldset {
  margin-bottom: 1.25rem;

  ::v-deep(.p-fieldset-legend) {
    font-weight: 600;
    font-size: 0.95rem;
  }

  ::v-deep(.p-fieldset-content) {
    padding: 1rem 0.5rem 0.5rem;
  }

  .p-field {
    margin-bottom: 1rem;

    label {
      display: block;
      margin-bottom: 0.35rem;
      font-size: 0.85rem;
      font-weight: 500;
      color: var(--text-color-secondary, #6c757d);
    }
  }
}

.dg-required {
  color: #e24c4c;
  font-weight: 700;
  margin-left: 2px;
}

.dg-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px dashed var(--surface-border, #dee2e6);

  &--start {
    justify-content: flex-start;
    border-top: none;
    padding-top: 0;
  }
}

.dg-subheader {
  margin: 1.25rem 0 0.5rem;
  display: flex;
  align-items: center;
  font-weight: 600;
  color: var(--text-color, #495057);
}

.dg-parts-header {
  margin-bottom: 0.25rem;

  small {
    font-weight: 600;
    color: var(--text-color-secondary, #6c757d);
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.4px;
  }
}

.dg-parts-row {
  align-items: center;
  padding: 0.25rem 0;
  border-bottom: 1px solid var(--surface-border, #f1f3f5);

  &:last-child {
    border-bottom: none;
  }

  .p-field {
    margin-bottom: 0.5rem;
  }
}
</style>
